

// GET FINAL DECISIONS
export const GET_FINAL_DECISIONS         = "GET_FINAL_DECISIONS";
export const GET_FINAL_DECISIONS_SUCCESS = "GET_FINAL_DECISIONS_SUCCESS";
export const GET_FINAL_DECISIONS_FAIL    = "GET_FINAL_DECISIONS_FAIL";

export const GET_RETEST_CANDIDATES = "GET_RETEST_CANDIDATES";
export const GET_RETEST_CANDIDATES_SUCCESS = "GET_RETEST_CANDIDATES_SUCCESS";
export const GET_RETEST_CANDIDATES_FAIL = "GET_RETEST_CANDIDATES_FAIL";